"use strict";

"user strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var singletonClient = false;

var APIClient = (function () {
    function APIClient() {
        _classCallCheck(this, APIClient);

        this._token;
    }

    _createClass(APIClient, [{
        key: "toQueryString",
        value: function toQueryString(obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }
            return str.join("&");
        }
    }, {
        key: "fetch",
        value: (function (_fetch) {
            function fetch(_x, _x2, _x3) {
                return _fetch.apply(this, arguments);
            }

            fetch.toString = function () {
                return _fetch.toString();
            };

            return fetch;
        })(function (endpoint, method, payload) {
            var _headers = { 'Accept': 'application/json' };
            var _url = undefined;
            var _payload = undefined;

            if (this._token) {
                _headers.Authorization = "Bearer " + this._token;
            }

            if (endpoint.indexOf('https') > -1) {
                _url = endpoint;
            } else {
                _url = "https://api.spotify.com/v1" + endpoint;
            }

            if (method === 'GET') {
                if (payload) {
                    var separator = _url.indexOf('?') !== -1 ? "&" : "?";
                    _url = _url + separator + this.toQueryString(payload);
                }
            } else {
                _payload = JSON.stringify(payload);
            }

            var checkStatus = function checkStatus(response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    var error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
            };

            var parseJSON = function parseJSON(response) {
                return response.json();
            };

            return fetch(_url, {
                method: method || 'GET',
                headers: _headers,
                body: _payload
            }).then(checkStatus).then(parseJSON);
        })
    }, {
        key: "loginRequest",
        value: function loginRequest(url) {
            return this.fetch(url);
        }
    }, {
        key: "request",
        value: function request(url, method, payload) {
            return this.fetch(url, method, payload);
        }
    }, {
        key: "token",
        set: function set(value) {
            this._token = value;
        },
        get: function get() {
            return this._token;
        }
    }]);

    return APIClient;
})();

if (!singletonClient) {
    singletonClient = new APIClient();
}

exports["default"] = singletonClient;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/services/APIClient.js
 ** module id = 152
 ** module chunks = 0
 **/